
export default (function (change) {
  window.scrollBy(change.x, change.y);
});


// WEBPACK FOOTER //
// ./~/react-beautiful-dnd/esm/view/window/scroll-window.js